import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { WalletsReducerState } from '../types'
import getFlattenWalletFromDetailsResponse from '../utils/getFlattenWalletFromDetailsResponse'

import { fetchPrepaidWallet } from './walletsThunks'

const initialWalletsState: WalletsReducerState = {
  currentWalletDetails: null,
  isWalletTopUpModalVisible: false,
}

const walletsSlice = createSlice({
  name: 'wallets',
  initialState: initialWalletsState,
  reducers: {
    setWalletTopUpModalVisible(
      state: WalletsReducerState,
      action: PayloadAction<boolean>,
    ) {
      state.isWalletTopUpModalVisible = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchPrepaidWallet.fulfilled, (state, action) => {
      if (action.payload) {
        const flattenWalletDetails = getFlattenWalletFromDetailsResponse(
          action.payload,
        )
        state.currentWalletDetails = flattenWalletDetails
      } else {
        state.currentWalletDetails = null
      }
    })
  },
})

export const { setWalletTopUpModalVisible } = walletsSlice.actions

export default walletsSlice.reducer
